import { PaginationApi, Pagination } from '../types';

export const paginationModel = (data?: PaginationApi): Pagination => ({
  currentPage: data?.current_page ?? 0,
  totalPages: data?.total_pages ?? 0,
  totalCount: data?.total_count ?? 0,
  nextPage: data?.next_page ?? 0,
  prevPage: data?.prev_page ?? 0,
});
